<template>
  <div>
    <div class="container-fluid login">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-10 col-sm-8 mx-auto login-form">

            <router-link to="/" class="content-logo-principal">
              <div>
                <h1>
                  <a href="https://royalpag.com/">
                      <img :src="img"  style="max-width: 250px !important; width: 250px">
                  </a></h1>
              </div>
            </router-link>
            <div v-if="!senhaAlterada">
              <h2 class="text-center text-default-gray logo_h2" style="font-size: 16px; font-family: Roboto;">
                Redefina a sua senha!
              </h2>
              <p class="text-center text-default-gray" style="font-size: 14px; font-family: Roboto; margin-bottom: 0px !important;">Preencha os campos abaixo para redefinir sua senha.</p>
              <div class="card-body pt-3">
                <div class="row">
                  <div class="col-12">
                    <form class="well" @submit.prevent="submit">
                      <div class="form-group">
                        <input placeholder="Senha" type="password" class="form-control here" :class="{ invalid: $v.usuario.senha.$error }" @input="$v.usuario.senha.$touch()" v-model="usuario.senha">
                        <span v-if="$v.usuario.senha.$dirty && !$v.usuario.senha.required" class="invalid">Campo obrigatório!</span>
                        <span v-if="$v.usuario.senha.required && !$v.usuario.senha.minLength" class="invalid">Senha mínimo {{$v.usuario.senha.$params.minLength.min}} caracteres</span>
                      </div>
                      <div class="form-group">
                        <input placeholder="Senha novamente" type="password" class="form-control here" :class="{ invalid: $v.senhaVerificacao.$error }" @input="$v.senhaVerificacao.$touch()" v-model="senhaVerificacao">
                        <span v-if="$v.senhaVerificacao.$dirty && !$v.senhaVerificacao.required" class="invalid">Campo obrigatório!</span>
                        <span v-if="$v.senhaVerificacao.required && !$v.senhaVerificacao.minLength" class="invalid">Senha mínimo {{$v.senhaVerificacao.$params.minLength.min}} caracteres</span>
                        <span v-if="$v.senhaVerificacao.required && $v.senhaVerificacao.minLength && !$v.senhaVerificacao.isOk" class="invalid">Senhas não conferem.</span>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <input type="submit" value="Recuperar" :disabled="!isWholeModelValid" class="btn btn-primary btn-block mb-3"/>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <span style="padding-left: 15px">Lembrou a senha? <router-link to="/auth/login" exact>Voltar</router-link></span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                Senha alterada com sucesso!
              </h2>
              <div class="form-group">
                <input type="reset" :style="color" @click.prevent="voltar" value="Entrar" class="btn btn-primary btn-block"/>
              </div>
              <div class="form-group">
                <div v-show="!isWholeRedirect" class="form-group text-center pb-0 mb-0 text-default-gray" style="padding-top: 3px; font-weight: bold">{{contador}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import localforage from 'localforage'
  import { required, minLength } from 'vuelidate/lib/validators'
  import { mapActions } from 'vuex'
  import site_style from '@/service/site_style'

  export default {
    name: 'Register',
    computed: {
      isWholeRedirect () {
        return this.tempo === 0
      },
      isWholeModelValid () {
        return !this.$v.$invalid
      }
    },
    mounted () {
      if (window.location.href.indexOf('?') !== -1) {
        if (this.$route.query && this.$route.query.rpu) {
          this.usuario.value = this.$route.query.rpu
        }
      }
    },
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        tempoTemp: 10,
        tempo: 10,
        contador: '',
        senhaAlterada: false,
        usuario: {
          key: '',
          value: '',
          senha: '',
          codigoEmail: ''
        },
        senhaVerificacao: ''
      }
    },
    validations: {
      usuario: {
        senha: {
          required,
          minLength: minLength(6)
        }
      },
      senhaVerificacao: {
        required,
        minLength: minLength(6),
        isOk (pass) { return this.checkPasswords(pass) }
      }
    },
    methods: {
      ...mapActions('usuarios', ['alterarSenhaUsuario']),
      checkPasswords (pass) {
        return (pass === this.usuario.senha)
      },
      countdown () {
        if ((this.tempo - 1) >= 0) {
          var seg = this.tempo % 60
          if (seg <= 9) {
            seg = '0' + seg
          }
          this.contador = 'Você será redirecionado em: ' + seg + ' segundo(s).'
          setTimeout(() => {
            this.tempo--
            this.countdown()
          }, 1000)
          // console.log(this.tempo, this.isWholeSendSms)
        } else {
          this.tempo = 0
          this.contador = 'Você será redirecionado em: 0 segundo(s).'
          this.$router.push({ name: 'auth.index' })
        }
      },
      voltar () {
        this.$router.push({ name: 'auth.index' })
      },
      async submit () {
        let self = this
        this.usuario.key = 'I-INA-SYSTEM'
        const verb = 'put'
        const { usuario } = this
        await this.alterarSenhaUsuario({ verb, usuario }).then((message) => {
          if (message) {
            console.log(message)
            localforage.setItem(message.key, message.value)
            self.senhaAlterada = true
            self.countdown()
          }
        })
      }
    }
  }
</script>

<style src="../../assets/css/login.css" scoped></style>

<style scoped>
  .login {
    padding-bottom: 2%;
    width: 100%;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%); */
    background-color: #eee;
    overflow-y: auto;
  }
  .submit-btn {
    background-color: rgba(255,255,255, .2);
  }
</style>




// WEBPACK FOOTER //
// reset.vue?3f3d43be